import { z } from 'zod';
import { tabBaseSchema } from '../base';
import { responsiveSchema, responsiveBooleanSchema, responsiveStringSchema } from '../../../utils';
import { animationFeature } from '../../../features';
import { responsiveCornersSchema, responsiveNumberWithUnitSchema, responsiveSpacingSchema } from '../../../mixins';

/**
 * How v0 stored a colour: the `{ value, presetName }` pair. v1 stores one string
 * (`mixins/color-value`); this stays here so rows saved in v0 still parse on
 * their way to the migration.
 */
const responsiveColorPairSchema = responsiveSchema(
    z.object({
        value: z.string().nullish(),
        presetName: z.string().nullish(),
    })
);

export const tabDefaultDataSchema = z.object({
    placement: z.enum(['top', 'left', 'right']),
    header: z.object({
        width: responsiveNumberWithUnitSchema,
        backgroundColor: responsiveColorPairSchema,
        activeBackgroundColor: responsiveColorPairSchema,
        textColor: responsiveColorPairSchema,
        fontSize: responsiveNumberWithUnitSchema,
        fontWeight: responsiveStringSchema,
        fontStyle: responsiveStringSchema,
        textTransform: responsiveStringSchema,
        activeTextColor: responsiveColorPairSchema,
        activeContourColor: responsiveColorPairSchema,
        activeContourSide: responsiveSchema(z.enum(['top', 'left', 'right', 'bottom']).nullable()),
        padding: responsiveSpacingSchema,
        borderRadius: responsiveCornersSchema,
        separator: responsiveBooleanSchema,
        separatorColor: responsiveColorPairSchema,
    }),
    body: z.object({
        backgroundColor: responsiveColorPairSchema,
        borderRadius: responsiveCornersSchema,
        padding: responsiveSpacingSchema,
    }),
    tabs: z.array(
        z.object({
            title: z.string(),
            contentEntityId: z.string(),
            isActive: z.boolean(),
        })
    ),
    animation: animationFeature.fieldSchema,
});

export const tabDefaultSchema = tabBaseSchema.extend({
    entitySubType: z.literal('default'),
    props: tabDefaultDataSchema,
    version: z.literal(0),
});

export const tabDefaultV0Schema = tabDefaultSchema;
export type TabDefaultV0 = z.output<typeof tabDefaultV0Schema>;
